/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Ortak asistan çalışma durumu. Tek kaynak Core'dur.
 */
import { assistantWorkCanCancel, assistantWorkCopy } from './assistant-work-client';
import type { AssistantWorkController } from './useAssistantWork';
import './AssistantWorkStatus.css';

export function AssistantWorkStatus({ work, language }: { work: AssistantWorkController; language?: string }) {
  const copy = assistantWorkCopy(language);
  if (!work.enabled || (!work.items.length && !work.error && !work.submitting && !work.loading && !work.hasPrevious)) return null;
  return <section className="assistant-work-status" aria-label={copy.title} aria-busy={work.loading || work.submitting}>
    <div className="assistant-work-status-heading"><strong>{copy.title}</strong>
      <button type="button" className="btn btn-secondary btn-sm" onClick={work.refresh} disabled={work.loading || work.submitting}>{copy.refresh}</button></div>
    {work.submitting ? <p role="status">{copy.accepting}</p> : null}
    {work.error ? <p role="alert">{work.error}</p> : null}
    {work.uncertain ? <div><p>{copy.uncertain}</p><button type="button" className="btn btn-secondary btn-sm" disabled={work.submitting} onClick={work.retry}>{copy.retry}</button></div> : null}
    <ul>{work.items.map(item => <li key={item.runId} data-work-id={item.runId}>
      <div className="assistant-work-status-heading"><strong>{item.worker.name}</strong><span role="status">{copy.statuses[item.status]}</span></div>
      {item.question ? <p>{item.question}</p> : null}
      {item.resultMissing ? <p role="alert">{copy.missing}</p> : null}
      {item.cancellationRequested && item.recoveryRequired ? <p>{copy.recovery}</p> : null}
      {assistantWorkCanCancel(item) ? <button type="button" className="btn btn-secondary btn-sm"
        disabled={work.cancelling.includes(item.runId)} onClick={() => void work.cancel(item.runId)}
        aria-label={`${copy.stop}: ${item.worker.name}`}>{copy.stop}</button> : null}
    </li>)}</ul>
    {work.hasPrevious || work.nextCursor ? <nav aria-label={copy.title} className="assistant-work-status-heading">
      <button type="button" className="btn btn-secondary btn-sm" disabled={!work.hasPrevious || work.loading} onClick={work.previous}>{copy.previous}</button>
      <button type="button" className="btn btn-secondary btn-sm" disabled={!work.nextCursor || work.loading} onClick={work.next}>{copy.next}</button>
    </nav> : null}
  </section>;
}
